// Find-references feature module — registers the workspace component for
// the `references-tab` workspace type and re-exports the public surface.

import { registerWorkspaceComponent } from '../../workspace/core/registry/workspaceRegistry';

import { ReferencesTab } from './ReferencesTab';

registerWorkspaceComponent('references-tab', ReferencesTab);

export { ReferencesTab } from './ReferencesTab';
export { findReferences } from './findReferencesService';
export { openReferencesTab } from './openReferencesTab';
export {
  FIND_REFERENCES_IN_TAB_ACTION_ID,
  FIND_REFERENCES_IN_TAB_LABEL,
  createFindReferencesInTabAction,
  runFindReferencesInTab,
} from './findReferencesInTabAction';
export { findBufferReferenceRanges } from './bufferReferenceRanges';
export {
  PEEK_REFERENCE_SCHEME,
  buildPeekReferenceUri,
  parsePeekReferenceUri,
} from './peekReferenceUri';
export {
  __peekReferenceModelUrisForTest,
  lookupPeekReferenceModel,
} from './peekReferenceModels';
export type {
  ReferencesTabContent,
  ReferencesTabStatus,
} from './referencesTabTypes';
